export const findDeviceMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Device>,
  deviceId: string,
): uui.domain.ui.map.markers.Device | undefined => {
  const marker = markers[deviceId]

  return marker
}
